function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { colors } from '../../theme/index.js';
const ContentBlock = /*#__PURE__*/React.forwardRef((props, ref) => {
  const style = {
    backgroundColor: colors.surface,
    boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
    display: 'block',
    margin: 'auto auto 30px auto',
    padding: '30px',
    position: 'relative',
    zIndex: 3,
    ...props.style
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, props, {
    style: style
  }), props.children);
});
export default ContentBlock;